import Mapa from './mapa.service';
import directionDirective from './direction.directive';
import mapaDirective from './mapa.directive';


export default (ngModule) => {
  ngModule.service('Mapa', Mapa);
  directionDirective(ngModule);
  mapaDirective(ngModule);
};




/** WEBPACK FOOTER **
 ** ../~/tslint-loader!./common/components/mapa/mapa.config.ts
 **/